<template>
  <v-sheet class="mx-auto pa-3" color="#F6F7F8" max-width="375">
    <budget-header
      :current-budget="selected_budget"
      :budgets="budgets"
      @budget-selected="onBudgetSelected"
    />
    
    <budget-details-card
      v-if="selected_budget"
      class="mt-6"
      :spent="Number(selected_budget.all_spent_amount)"
      :total="Number(selected_budget.overall_income)"
    />

    <div class="text-subtitle-1 font-weight-medium px-2 mt-6 mb-3">
      Категорії
    </div>
    
    <template v-for="budget_category in budget_categories"> 
      <budget-category-card
        :key="budget_category.id"
        :limit="budget_category.planned_amount"
        :spent="budget_category.spent_amount"
        :categoryName="budget_category.category.display_name"
        :categoryIconName="budget_category.category.icon ? budget_category.category.icon.name : null"
        :categoryColor="budget_category.category.icon ? budget_category.category.icon.color : null"
        class="mt-3"
      >
      </budget-category-card>
    </template>
  </v-sheet>
</template>

<script>
import BudgetCategoryCard from "../components/BudgetCategoryCard.vue";
import BudgetHeader from "../components/BudgetHeader.vue";
import BudgetDetailsCard from "../components/BudgetDetailsCard.vue";

export default {
  name: "BudgetView",

  components: {
    BudgetCategoryCard,
    BudgetHeader,
    BudgetDetailsCard,
  },

  props: {
    id: {
      type: String,
      required: false
    }
  },

  data: () => ({
    selected_budget: "",
  }),

  watch: {
    selected_budget(new_selected_budget) {
      if (new_selected_budget && new_selected_budget.id) {
        this.fetchBudgetCategories(new_selected_budget.id);
        // Store the current budget in the store for other components to use
        this.$store.commit('budgets/setBudget', new_selected_budget);
      }
    },
  },
  methods: {
    fetchBudgets() {
      return this.$store.dispatch("budgets/fetchBudgets").then((budgets) => {
        // Якщо id не передано та немає збереженого бюджету, використовуємо перший бюджет
        if (!this.id && !this.current_budget) {
          this.selected_budget = budgets[0];
          // Store the current budget in the store
          this.$store.commit('budgets/setBudget', budgets[0]);
        } else if (!this.id && this.current_budget) {
          // Якщо є збережений бюджет, використовуємо його
          this.selected_budget = this.current_budget;
        }
        return budgets;
      });
    },
    onBudgetSelected(budget) {
      this.selected_budget = budget;
      // Store the current budget in the store
      this.$store.commit('budgets/setBudget', budget);
      // Оновлюємо URL, щоб відображати ID вибраного бюджету
      this.$router.push({ name: 'budget', params: { id: budget.id }});
    },
    fetchBudgetById(id) {
      return this.$store.dispatch("budgets/fetchBudget", id).then((budget) => {
        this.selected_budget = budget;
        // Store the current budget in the store
        this.$store.commit('budgets/setBudget', budget);
      });
    },
    fetchBudgetCategories(budget_id) {
      return this.$store.dispatch("budgets/fetchBudgetCategories", budget_id);
    },
  },
  computed: {
    budgets() {
      return this.$store.getters["budgets/getBudgets"];
    },
    budget_categories() {
      return this.$store.getters["budgets/getBudgetCategories"];
    },
    current_budget() {
      return this.$store.getters["budgets/getCurrentBudget"];
    }
  },
  created() {
    // Спочатку завантажуємо список всіх бюджетів
    this.fetchBudgets().then(() => {
      // Якщо передано id, завантажуємо конкретний бюджет
      if (this.id) {
        this.fetchBudgetById(this.id);
      }
    });
  },
};
</script>

